/**
 * Type guard to check if a given object has a payload property.
 *
 */
export function hasPayload<T>(payload: undefined | T): payload is T {
  return (payload as T) !== undefined;
}
